import React from "react";

// UI
import { Box, Group, Image, Text, Button } from "@mantine/core";
// components
import { LanguageSelectStandalone } from "@components/LanguageSelect/index";
// assets
import mightierLogoSvg from "@assets/images/mightier-logo.svg";

// DEV - TODO GET RID OF THIS LATER
import { useRouter } from "@tanstack/react-router";
import { TanstackMantineLink } from "@components/tanstack-maintine-link";
import { _useSurveyStateZustandStore } from "src/services/surveyHooks/survey-state-local-store";

const DebugButtons: React.FC = () => {
  const linksToExistingSurveys = [
    { id: "e509b16c-e5f7-48bd-95f0-162205380795", name: "Dev Test 1" },
    { id: "d58e852b-da66-410d-a903-701bec20222b", name: "Dev Test 2" },
    { id: "aa15ba94-82c2-4a47-ac1c-80a1f15966d8", name: "Intro Profile REAL" },
  ];

  const router = useRouter();

  const shouldShowDebugButtons =
    localStorage.getItem("surveyEngineShowDebugButtons") === "true";
  const isSurveyScreen = router.state.location.pathname.startsWith("/s/");

  if (!shouldShowDebugButtons || !isSurveyScreen) {
    return null;
  }

  return (
    <Box>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <Text ml="xl" fw="bold">
        DEVELOPMENT LINKS (please refresh after clicking a link)
      </Text>

      {linksToExistingSurveys.map((thing) => (
        <TanstackMantineLink
          to="/s/$surveyId"
          params={{ surveyId: thing.id }}
          search={{ meta: "eyJ1c2VyX2lkIjoiNTUzMyJ9" }}
          key={thing.id}
          ml="xl"
          fw="bold"
        >
          {thing.name}
        </TanstackMantineLink>
      ))}

      <Button
        ml="xl"
        onClick={() => {
          _useSurveyStateZustandStore.persist.clearStorage();
          window.location.reload();
        }}
        // eslint-disable-next-line i18next/no-literal-string
      >
        clear survey storage
      </Button>
    </Box>
  );
};

export const PageHeader = React.memo(function PageHeader() {
  return (
    <>
      <Group py="lg" px="xl" justify="space-between">
        <Image
          src={mightierLogoSvg}
          alt="mightier-logo"
          style={{
            width: "12rem",
            height: "auto",
          }}
        />
        <Box>
          <LanguageSelectStandalone includeLabel={false} />
        </Box>
      </Group>
      {/* TODO: get rid of this later!!! */}
      <DebugButtons />
    </>
  );
});
